var _defs, _circle, _rect, _rect2, _g, _circle2, _circle3, _path, _circle4, _circle5, _path2, _g2, _circle6, _path3, _circle7, _path4, _ellipse, _g3, _rect3, _rect4, _rect5, _circle8, _circle9, _path5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _g4, _path6, _path7, _g5, _path8, _g6, _circle10, _ellipse2, _path9, _rect14, _rect15, _g7, _rect16, _path10, _rect17, _rect18, _path11, _rect19, _rect20, _rect21, _circle11, _circle12, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#111827",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    fill: "#FDE801"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 292,
    r: 222,
    fill: "#FEF9C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 96,
    width: 80,
    height: 80,
    fill: "url(#dots)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 120,
    width: 80,
    height: 80,
    fill: "url(#dots)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 106L190 124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 106L370 124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 128V176",
    strokeDasharray: "5 7"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 130,
    r: 22,
    fill: "#FFFFFF",
    stroke: "#111827",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 124,
    r: 7,
    fill: "#111827"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159 144a11 11 0 0 1 22 0z",
    fill: "#111827"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 130,
    r: 22,
    fill: "#FFFFFF",
    stroke: "#111827",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 124,
    r: 7,
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379 144a11 11 0 0 1 22 0z",
    fill: "#111827"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 96,
    r: 32,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 4
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 88,
    r: 10,
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264 116a16 16 0 0 1 32 0z",
    fill: "#111827"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 70,
    r: 12,
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300 70l4 4 8-9",
    stroke: "#FDE801",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 392,
    rx: 176,
    ry: 10,
    fill: "#111827",
    opacity: 0.08
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 176,
    width: 268,
    height: 180,
    rx: 14,
    fill: "#111827"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 188,
    width: 244,
    height: 152,
    rx: 6,
    fill: "#1F2937"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 352,
    width: 340,
    height: 20,
    rx: 10,
    fill: "#D1D5DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 352,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#9CA3AF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 238,
    r: 26,
    fill: "#FDE801"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 231,
    r: 8,
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195 254a13 13 0 0 1 26 0z",
    fill: "#111827"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 220,
    width: 112,
    height: 12,
    rx: 6,
    fill: "#F9FAFB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 241,
    width: 82,
    height: 8,
    rx: 4,
    fill: "#FDE801"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 257,
    width: 124,
    height: 6,
    rx: 3,
    fill: "#6B7280"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 290,
    width: 50,
    height: 18,
    rx: 9,
    fill: "#374151"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 290,
    width: 40,
    height: 18,
    rx: 9,
    fill: "#FDE801"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 290,
    width: 62,
    height: 18,
    rx: 9,
    fill: "#374151"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 290,
    width: 34,
    height: 18,
    rx: 9,
    fill: "#374151"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 320,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#4B5563"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 236,
    width: 112,
    height: 112,
    rx: 16,
    fill: "#FFFFFF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 293l30 15 30-15M54 308l30 15 30-15",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84 258l30 15-30 15-30-15z",
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 216,
    width: 110,
    height: 96,
    rx: 16,
    fill: "#111827"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M464 248l-16 16 16 16M498 248l16 16-16 16M488 244l-14 40",
    stroke: "#FDE801",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 398,
    width: 156,
    height: 84,
    rx: 16,
    fill: "#111827"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 440,
    r: 22,
    stroke: "#FDE801",
    strokeWidth: 4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 440,
    rx: 9,
    ry: 22,
    stroke: "#FDE801",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74 440h44",
    stroke: "#FDE801",
    strokeWidth: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 428,
    width: 54,
    height: 8,
    rx: 4,
    fill: "#F9FAFB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 446,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#6B7280"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 386,
    width: 146,
    height: 110,
    rx: 16,
    fill: "#FFFFFF"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 404,
    width: 18,
    height: 18,
    rx: 5,
    fill: "#FDE801"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M410 413l4 4 7-8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 409,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#111827"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 432,
    width: 18,
    height: 18,
    rx: 5,
    fill: "#FDE801"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M410 441l4 4 7-8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 437,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#111827"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 460,
    width: 18,
    height: 18,
    rx: 5,
    fill: "#E5E7EB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 465,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#D1D5DB"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 70,
    r: 9,
    fill: "#111827"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 500,
    r: 7,
    fill: "#FDE801",
    stroke: "#111827",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110 76l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M520 350l8 8m0-8l-8 8",
    stroke: "#111827",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIllustration);
export default __webpack_public_path__ + "static/media/about-illustration.93a3bbf4cf68c505998fca6115d92d92.svg";
export { ForwardRef as ReactComponent };